// Copyright (c) 2017 Deere & Company

import {
    FormattedMessage,
    injectIntl,
    intlShape
} from 'react-intl';
import React, {PropTypes} from 'react';
import {Checkbox} from 'cap-it-ui.toggles';

function handleChange(event) {

    this.onInputChange(event.target.value);

}

function handleCheckboxChange() {

    this.onCheckboxChange(!this.isSelected);

}

const CreateLayoutModalBody = props => {

    const setAsDefault = props.intl.formatMessage({id: 'SET_AS_DEFAULT'});

    return (
        <div className='layout-modal-body'>
            <div className='form-group'>
                <label className='form-group-title'>
                    <FormattedMessage id='LAYOUT_NAME'/>
                </label>
                <input
                    maxLength={30}
                    onChange={props::handleChange}
                    value={props.layoutName}
                />
            </div>
            <div className='form-group'>
                <Checkbox
                    id='create-layout-set-default'
                    onChange={props::handleCheckboxChange}
                    selected={props.isSelected}
                >
                    {setAsDefault}
                </Checkbox>
            </div>
        </div>
    );

};

CreateLayoutModalBody.displayName = 'CreateLayoutModalBody';
CreateLayoutModalBody.propTypes = {
    intl: intlShape.isRequired,
    isSelected: PropTypes.bool.isRequired,
    layoutName: PropTypes.string.isRequired,
    onCheckboxChange: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired
};

export default injectIntl(CreateLayoutModalBody);



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-variant-modals/create-layout-modal/create-layout-modal-body.js